import { Divider, Stack } from '@mui/material'

import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

import { roundingNumber } from 'components/shared/processes'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'

export const HerdStructureWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (error || !permissions.license_identification) return null

	const milky = statistics?.herd?.milky
	const dry = statistics?.herd?.dry

	return (
		<BaseWidget
			path={'/cattles'}
			isLoading={loading}
			pathLable='Перейти в поголовье'
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='column' gap='4px'>
					{milky === null || milky === undefined ? (
						<TypographySecondary>Нет данных</TypographySecondary>
					) : (
						<TypographyPrimary16Bold>
							{roundingNumber(milky, 1).toLocaleString()}
						</TypographyPrimary16Bold>
					)}
					<TypographyPrimary>Дойных голов</TypographyPrimary>
				</Stack>

				<Divider />

				<Stack direction='column' gap='4px'>
					{dry === null || dry === undefined ? (
						<TypographySecondary14>Нет данных</TypographySecondary14>
					) : (
						<TypographyPrimary16Bold>
							{roundingNumber(dry, 1).toLocaleString('ru-RU')}
						</TypographyPrimary16Bold>
					)}
					<TypographyPrimary>Сухостойных голов</TypographyPrimary>
				</Stack>
			</Stack>
		</BaseWidget>
	)
}
